import { render, staticRenderFns } from "./OnlineAppointments.vue?vue&type=template&id=57068ede&scoped=true"
import script from "./OnlineAppointments.vue?vue&type=script&lang=js"
export * from "./OnlineAppointments.vue?vue&type=script&lang=js"
import style0 from "./OnlineAppointments.vue?vue&type=style&index=0&id=57068ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57068ede",
  null
  
)

export default component.exports